
import React from 'react';
import usePageTracking from '@/hooks/usePageTracking';

// This component doesn't render anything but tracks page views
const PageTracker: React.FC = () => {
  usePageTracking();
  return null;
};

export default PageTracker;
